var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Credit Card")]), _vm._v(" "), _c('small', [_vm._v("Form")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Enter your name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Credit Card Number"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "ccnumber",
      "placeholder": "0000 0000 0000 0000"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Month"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": true,
      "options": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Year"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": true,
      "options": [2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025]
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "CVV/CVC"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "cvv",
      "placeholder": "123"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Company")]), _vm._v(" "), _c('small', [_vm._v("Form")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Company"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "company",
      "placeholder": "Enter your company name"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "VAT"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "vat",
      "placeholder": "PL1234567890"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Street"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "street",
      "placeholder": "Enter street name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "City"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "city",
      "placeholder": "Enter your city"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Postal Code"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "postal-code",
      "placeholder": "Postal Code"
    }
  })], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Country"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "country",
      "placeholder": "Country name"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Basic Form")]), _vm._v(" Elements\n        ")]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "description": "Let us know your full name.",
      "label": "Enter your name",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Static",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-input-static', {
    attrs: {
      "type": "text",
      "value": "Username"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "description": "This is a help text",
      "label": "Text Input",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Text"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "description": "Please enter your email",
      "label": "Email Input",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email",
      "placeholder": "Enter your email"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "description": "Please enter a complex password",
      "label": "Password Input",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password",
      "placeholder": "Enter your password"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Disabled Input",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "disabled": true,
      "placeholder": "Disabled"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Textarea",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": true,
      "rows": 9,
      "placeholder": "Content.."
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Select",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": true,
      "options": ['Please select', 'Option 1', 'Option 2', 'Option 3'],
      "value": "Please select"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Select large",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-select', {
    attrs: {
      "size": "lg",
      "plain": true,
      "options": ['Please select', 'Option 1', 'Option 2', 'Option 3'],
      "value": "Please select"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Select small",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-select', {
    attrs: {
      "size": "sm",
      "plain": true,
      "options": ['Please select', 'Option 1', 'Option 2', 'Option 3'],
      "value": "Please select"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Disabled select",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": true,
      "options": ['Please select', 'Option 1', 'Option 2', 'Option 3'],
      "disabled": true,
      "value": "Please select"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Select",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": true,
      "multiple": true,
      "options": [{
          text: 'Please select some item',
          value: null
        },
        {
          text: 'This is First option',
          value: 'a'
        }, {
          text: 'Default Selected Option',
          value: 'b'
        }, {
          text: 'This is another option',
          value: 'c'
        }, {
          text: 'This one is disabled',
          value: 'd',
          disabled: true
        }
      ],
      "value": [null, 'c']
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Radios",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-radio', {
    attrs: {
      "plain": true,
      "options": [{
          text: 'Option 1 ',
          value: '1'
        },
        {
          text: 'Option 2 ',
          value: '2'
        },
        {
          text: 'Option 3 ',
          value: '3'
        }
      ],
      "value": "1",
      "stacked": ""
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Radios - custom",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-radio', {
    attrs: {
      "options": [{
          text: 'Option 1',
          value: '1'
        },
        {
          text: 'Option 2',
          value: '2'
        },
        {
          text: 'Option 3',
          value: '3'
        }
      ],
      "value": "1",
      "stacked": ""
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Inline radios",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-radio', {
    attrs: {
      "plain": true,
      "options": [{
          text: 'Option 1 ',
          value: '1'
        },
        {
          text: 'Option 2 ',
          value: '2'
        },
        {
          text: 'Option 3 ',
          value: '3'
        }
      ],
      "value": "1"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Inline radios - custom",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-radio', {
    attrs: {
      "options": [{
          text: 'Option 1',
          value: '1'
        },
        {
          text: 'Option 2',
          value: '2'
        },
        {
          text: 'Option 3',
          value: '3'
        }
      ],
      "value": "1"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Checkboxes",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "plain": true,
      "value": "1"
    }
  }, [_vm._v("Option 1")]), _c('br'), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "plain": true,
      "value": "2"
    }
  }, [_vm._v("Option 2")]), _c('br'), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "plain": true,
      "value": "3"
    }
  }, [_vm._v("Option 3")]), _c('br')], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Inline checkboxes",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "plain": true,
      "value": "1"
    }
  }, [_vm._v("Option 1")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "plain": true,
      "value": "2"
    }
  }, [_vm._v("Option 2")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "plain": true,
      "value": "3"
    }
  }, [_vm._v("Option 3")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Checkboxes - custom",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option 1")]), _c('br'), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option 2")]), _c('br'), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Option 3")]), _c('br')], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Inline checkboxes - custom",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option 1")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option 2")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Option 3")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "File input",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-file', {
    attrs: {
      "plain": true
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Multiple file input",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-file', {
    attrs: {
      "plain": true,
      "multiple": true
    }
  })], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])], 1)], 1), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Inline")]), _vm._v(" Form\n        ")]), _vm._v(" "), _c('b-form', {
    attrs: {
      "inline": true
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Jane Doe"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "email",
      "placeholder": "ane.doe@example.com"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Horizontal")]), _vm._v(" Form\n        ")]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Email",
      "description": "Please enter your email.",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email",
      "placeholder": "Enter Email.."
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Password",
      "description": "Please enter your password.",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email",
      "placeholder": "Enter Password.."
    }
  })], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])], 1)], 1), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Normal")]), _vm._v(" Form\n        ")]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Email",
      "description": "Please enter your email."
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email",
      "placeholder": "Enter Email.."
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Password",
      "description": "Please enter your password."
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email",
      "placeholder": "Enter Password.."
    }
  })], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])], 1)], 1), _vm._v(" "), _c('b-card', {
    attrs: {
      "no-block": true
    }
  }, [_c('div', {
    slot: "header"
  }, [_vm._v("\n          Input "), _c('strong', [_vm._v("Grid")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-3"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-4"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-5"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-7"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-8"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-9"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-10"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-11"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-11"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-12"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Login")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])], 1)]), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_vm._v("\n          Input "), _c('strong', [_vm._v("Sizes")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Small input",
      "label-cols": 5,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "size": "sm",
      "placeholder": "size='sm'"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Normal  input",
      "label-cols": 5,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "normal"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Large input",
      "label-cols": 5,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "size": "lg",
      "placeholder": "size='lg'"
    }
  })], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])], 1)], 1), _vm._v(" "), _c('b-card', {
    attrs: {
      "no-block": true
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Validation states")]), _vm._v(" Form\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-form-control-label",
    attrs: {
      "for": "inputSuccess1"
    }
  }, [_vm._v("Input with success")]), _vm._v(" "), _c('input', {
    staticClass: "form-control is-valid",
    attrs: {
      "type": "text",
      "id": "inputSuccess1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-form-control-label",
    attrs: {
      "for": "inputError1"
    }
  }, [_vm._v("Input with error")]), _vm._v(" "), _c('input', {
    staticClass: "form-control is-invalid",
    attrs: {
      "type": "text",
      "id": "inputError1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v("\n              Please provide a valid informations.\n            ")])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Icon/Text")]), _vm._v(" Groups\n        ")]), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Username"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "right": "<i class='fa fa-envelope-o'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email",
      "placeholder": "Email"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-euro'></i>",
      "right": ".00"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "ex. $1.000.000"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Buttons")]), _vm._v(" Groups\n        ")]), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Username"
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "left"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "type": "email",
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "type": "email",
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "left"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])], 1), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Dropdowns")]), _vm._v(" Groups\n        ")]), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', [_c('b-input-group-button', {
    slot: "left"
  }, [_c('b-dropdown', {
    attrs: {
      "text": "Action",
      "variant": "primary"
    }
  }, [_c('b-dropdown-item', [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', [_vm._v("Something else here...")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled action")])], 1)], 1), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": "Username"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-dropdown', {
    attrs: {
      "text": "Action",
      "variant": "primary"
    }
  }, [_c('b-dropdown-item', [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', [_vm._v("Something else here...")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled action")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', [_c('b-input-group-button', {
    slot: "left"
  }, [_c('b-dropdown', {
    attrs: {
      "text": "Split",
      "variant": "primary",
      "split": ""
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here...")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled action")])], 1)], 1), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": "..."
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-dropdown', {
    attrs: {
      "text": "Action",
      "variant": "primary"
    }
  }, [_c('b-dropdown-item', [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', [_vm._v("Something else here...")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled action")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_vm._v("\n          Use the grid for big devices! "), _c('small', [_c('code', [_vm._v(".col-lg-*")]), _vm._v(" "), _c('code', [_vm._v(".col-md-*")]), _vm._v(" "), _c('code', [_vm._v(".col-sm-*")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-md-8"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-md-4"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-md-7"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-md-5"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-md-6"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-md-6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-md-5"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-md-7"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-md-4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-md-8"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "danger"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-sm btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "primary"
    }
  }, [_vm._v("Action")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_vm._v("\n          Input Grid for small devices! "), _c('small', [_c('code', [_vm._v(".col-*")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-8"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-5"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-7"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-6"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-7"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-5"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-5"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-8"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": ".col-4"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "danger"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-sm btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "primary"
    }
  }, [_vm._v("Action")])], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_vm._v("\n          Example Form\n        ")]), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "Username",
      "right": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "Email",
      "right": "<i class='fa fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "Password",
      "right": "<i class='fa fa-asterisk'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-actions"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_vm._v("\n          Example Form\n        ")]), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "right": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Username"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "right": "<i class='fa fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email",
      "placeholder": "Email"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "right": "<i class='fa fa-asterisk'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password",
      "placeholder": "Password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-actions"
  }, [_c('b-button', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_vm._v("\n          Example Form\n        ")]), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Username"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email",
      "placeholder": "Email"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-asterisk'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password",
      "placeholder": "Password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-actions"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Form Elements\n        ")]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Prepended text",
      "description": "Here's some help text"
    }
  }, [_c('b-input-group', {
    attrs: {
      "left": "@"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Appended text",
      "description": "Here's some help text"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": ".00"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Append and prepend",
      "description": "Here's some help text"
    }
  }, [_c('b-input-group', {
    attrs: {
      "left": "$",
      "right": ".00"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Append with button",
      "description": "Here's some help text"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v("Go!")])], 1)], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Two-buttons append"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-button', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("Options")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "secondary"
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bd2c832","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/Forms.vue
// module id = 765
// module chunks = 1